import { createContext, useContext, useRef } from 'react';
import type { CafDashboard, CafDashboardWindow } from '../api/cafCorpus';

/** Private, memory-only figures and selection owned by one authenticated session. */
export interface DashboardSession {
  active: boolean;
  isCurrent?: () => boolean;
  acceptsAuthorization?: (authorization: string | null) => boolean;
  days: CafDashboardWindow;
  ready: Partial<Record<CafDashboardWindow, CafDashboard>>;
}
export const createDashboardSession = (): DashboardSession => ({ active: true, days: 14, ready: {} });
export const DashboardSessionContext = createContext<DashboardSession | null>(null);
export const useDashboardSession = () => {
  const owner = useContext(DashboardSessionContext);
  const local = useRef<DashboardSession>(createDashboardSession());
  return owner ?? local.current;
};
